var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"d_i-f im-music-player",class:{playing: _vm.state},on:{"click":_vm.onSwitch}},[_c('audio',{ref:"sound",attrs:{"src":_vm.src,"loop":""},on:{"play":_vm._onplay,"pause":_vm._onpause}})])}
var staticRenderFns = []

export { render, staticRenderFns }